import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled.svg`
  width: 22px;
  height: 22px;
  fill: currentColor;
`;

/** Filled vending-machine mark. Nav CSS overrides fill to white. */
const VendingMachineIcon: React.FC = () => (
  <StyledIcon viewBox="0 0 24 24" aria-hidden="true">
    <path
      fillRule="evenodd"
      d="M6.4 1.6h11.2c.7 0 1.2.5 1.2 1.2v18.4c0 .7-.5 1.2-1.2 1.2H6.4c-.7 0-1.2-.5-1.2-1.2V2.8c0-.7.5-1.2 1.2-1.2zm1.5 2.5h6.4v7.6H7.9V4.1zm.7 1.1h5v1.15h-5V5.2zm0 1.85h5v1.15h-5V7.05zm0 1.85h5V10h-5V8.9zM15.2 4.3h1.7v1.35h-1.7V4.3zm0 2h1.7v1.35h-1.7V6.3zm0 2h1.7v1.35h-1.7V8.3zm0 2h1.7V11h-1.7V10.3zM7.9 15.1h8.2v2.15H7.9V15.1z"
    />
  </StyledIcon>
);

export default VendingMachineIcon;
